import { Helmet } from 'react-helmet-async'

import { faGlobe } from '@fortawesome/pro-light-svg-icons'

import {
  Box, Button, Columns, DashboardModule,
} from '@domain-group/suit-theme'

import useCurrentUser from '@hooks/useCurrentUser'

import { getReportingPageAllowedReports } from '@functions/reporting'
import handleCallbackAction from '@functions/handleCallbackAction'

import PageHeader from '@components/PageHeader'
import Reporting from '@components/Reporting'

import useReporting from '@hooks/useReporting'

const PageContent = () => {
  const currentUserPayload = useCurrentUser()
  const { isBrandUser, isProviderUser, currentUser } = currentUserPayload

  const defaultValues = {
    brand_id: isBrandUser ? currentUser.brand_id : undefined,
    provider_id: isProviderUser ? currentUser.association_id : undefined,
  }

  const reportingPayload = useReporting({
    allowedReports: getReportingPageAllowedReports(currentUserPayload),
    defaultValues,
  })

  const {
    callbacks: {
      generateReport: generateFn,
    },
    loading,
    saveEnabled,
    urls: { reportingIndexUrl },
  } = reportingPayload

  const generateReportPayload = {
    callbacks: {
      action: generateFn,
    },
    toastText: 'Report Queued',
  }

  return (
    <>
      <Helmet>
        <title>Reporting | Realhub</title>
      </Helmet>

      <PageHeader
        activeTabBarItemKey="reporting"
        tabBarItems={[
          {
            href: reportingIndexUrl,
            icon: faGlobe,
            key: 'reporting',
            title: 'REPORTING',
          },
        ]}
        title="Reporting"
      />

      <Box paddingX="large" paddingTop={[112, 105]}>
        <Columns boxProps={{ marginTop: 'large' }} flexDirection={['column', 'column', 'row']}>
          <Columns.Main>
            <DashboardModule contentBoxProps={{ flexDirection: 'column' }} title="Generate Report">
              <Reporting reportingPayload={reportingPayload} />

              <DashboardModule.Footer>
                <DashboardModule.FooterRight>
                  <Button
                    buttonStyle="primaryEdit"
                    disabled={!saveEnabled}
                    // @ts-expect-error TS2322
                    ghost
                    loading={loading}
                    // @ts-expect-error TS2345
                    onClick={() => handleCallbackAction(generateReportPayload)}
                    size="medium"
                  >
                    Generate Report
                  </Button>
                </DashboardModule.FooterRight>
              </DashboardModule.Footer>
            </DashboardModule>
          </Columns.Main>
        </Columns>
      </Box>
    </>
  )
}

export default PageContent
